import { createSelector } from 'reselect';
import {
  isAppSell,
  isCollegeDistribute,
  isExchange,
  isQCD,
  isSell,
  isAutomaticSell,
} from '../../../utils/transactions-util';

/**
 * Simple selector to marketVolatility
 * @param state
 * @returns {marketVolatility|null}
 */
export const getMarketVolatility = (state) =>
  state.marketVolatility.marketVolatility || {};

export const getMarketVolatilityMessage = createSelector(
  getMarketVolatility,
  (marketVolatility) => {
    return isQCD()
      ? marketVolatility.sell?.charity?.volatilityMessage
      : isAppSell()
      ? marketVolatility.sell?.app?.volatilityMessage
      : isSell() || isAutomaticSell() || isQCD()
      ? marketVolatility?.sell?.mutualFund?.volatilityMessage
      : isCollegeDistribute()
      ? marketVolatility?.sell?.college?.volatilityMessage
      : isExchange()
      ? marketVolatility?.exchange
      : marketVolatility?.exchange?.college?.volatilityMessage;
  }
);
